import * as React from "react";
import { forwardRef } from "react";
const SvgIcShareCount = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M24.8692 1.59092C13.0896 -2.32729 -0.986639 7.13526 1.26991 21.0634C4.35887 40.1293 21.5054 41.2411 29.4911 36.4047C39.9358 30.0791 40.2007 19.3607 35.3869 10.3489", stroke: "#B693FF", strokeWidth: 1.25 }));
const ForwardRef = forwardRef(SvgIcShareCount);
export { ForwardRef as ReactComponent };
